var $6c3289ab94189038$exports = {};
$6c3289ab94189038$exports = {
    "valid": `V\xe1lido`
};


export {$6c3289ab94189038$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
